import { MutationTree } from 'vuex';
import { IMetaInfo, ILoginStore } from './shared.types';

const sharedMutations: MutationTree<ILoginStore> = {
  setOrganization(state, organization: any) {
    state.organization = organization;
  },

  setMetaInfo(state, metaInfo: IMetaInfo) {
    state.metaInfo = metaInfo;
  },

  setLocale(state, locale: string) {
    state.locale = locale;
  },

  setDocuments(state, documents: any) {
    state.documents = documents;
  },
};

export default sharedMutations;
